// ── Tax ──────────────────────────────────────────────────────

/** Translation keys used as the identifying `name` of the sales/BO tax rate rows. */
export const TAX_RATE_ROW_NAMES = {
  material: 'MATERIAL_RATE',
  labor: 'LABOR_RATE',
} as const;

export interface EstimateTaxRateRowModel {
  name: string;
  rate: number;
  cost: number;
  tdcPercentage: number;
  sellPrice: number;
}

export interface EstimateTaxRateHeaderRowModel {
  description: string;
  cost: number;
  tdcPercentage: number;
  sellPrice: number;
}

export interface EstimateTaxRateModel {
  headerRow: EstimateTaxRateHeaderRowModel;
  taxRateRows: EstimateTaxRateRowModel[];
}
